import { render, staticRenderFns } from "./questions.vue?vue&type=template&id=28b57982&"
import script from "./questions.js?vue&type=script&lang=js&"
export * from "./questions.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports